namespace $.$$ {

	export class $shm_hitalama_map_book extends $.$shm_hitalama_map_book {

		map_context() {
			return this.$.$mol_error_fence(
				()=> this.map().link().str,
				()=> '',
				()=> '',
			)
		}

		@ $mol_action
		history_open( event?: Event | null ) {
			if( event ) this.Map_page().history_showed( true )
			return event ?? null
		}
		
		widget_props_visible() {
			// return []
			return this.widget_for_settings()
				? [this.Widget_props()]
				: []
		}

		title() {
			return this.$.$mol_error_fence(
				()=> this.map().can_read() ? this.map().title() : 'Доступ к карте закрыт',
				error => {
					$shm_hitalama_resilience_report( 'map', error, this.map_context() )
					return 'Карта временно недоступна'
				},
				promise => {
					$shm_hitalama_telemetry_sentry.promise_watch( promise, `map title:${ this.map_context() }` )
					return 'Загрузка карты…'
				},
			)
		}

		@ $mol_action
		cut() {
			$shm_hitalama_profile.current()?.cut_map( this.map().link() )
		}

		failure_key( error: unknown ) {
			const normalized = error instanceof Error ? error : new Error( String( error ) )
			return JSON.stringify({ name: normalized.name, message: normalized.message })
		}

		failure_data( key: string ) {
			return this.$.$mol_error_fence(
				()=> JSON.parse( key ) as { name: string, message: string },
				()=> ({ name: 'Error', message: '' }),
			)
		}

		failure_title( _key: string ) {
			return 'Карта временно недоступна'
		}

		failure_message( _key: string ) {
			return $shm_hitalama_resilience_error_message( 'map' )
		}

		failure_details( key: string ) {
			const data = this.failure_data( key )
			return `${ data.name }: ${ data.message }`
		}

		failure_retry_visible( _key: string ) {
			return true
		}

		failure_page( error: unknown ) {
			$shm_hitalama_resilience_report( 'map', error, this.map_context() )
			return this.Failure_page( this.failure_key( error ) )
		}

		pages(): readonly ( any )[] {
			return super.pages()
		}

		page_sub(): readonly ( any )[] {
			const loading = this.$.$shm_hitalama_map_loading.current( this.map_context() )
			const body = this.$.$mol_error_fence(
				()=> {
					const map = this.map()
				const readable = loading ? loading.step( 'access', 'Проверка прав чтения карты' ).read( ()=> map.can_read() ) : map.can_read()
					if( !readable ) { loading?.fail( new Error( 'Доступ к карте закрыт' ) ); return [ this.Access_denied() ] }
					const prepare = ()=> {
						const latest = $shm_hitalama_map_migration.latest_version()
						if( map.widgets_reference().Version()?.val() !== latest && map.Version()?.val() !== undefined ) this.$.$shm_hitalama_map_migration.migrate( map )
					}
					if( loading ) loading.step( 'prepare', 'Проверка версии хранения и миграция карты' ).read( prepare )
					else prepare()
					return [ ... this.widget_list_view(), ... this.map_or_editor() ]
				},
				error => { loading?.fail( error ); return [ this.failure_page( error ) ] },
				promise => {
					$shm_hitalama_telemetry_sentry.promise_watch( promise, `map:${ this.map_context() }` )
					return []
				},
			)
			return [ this.Head(), ... body ]
		}

		widget_list_view(): readonly ( any )[] {
			return [
				...( this.editor_mode_enabled() || this.Head().widget_list_visible() ? [ this.Widgets() ] : [] ),
				...( this.rights_visible() ? [ this.Rights() ] : [] ),
			]
		}

		tool_modes_left() {
			return `${ this.widget_list_view().length * 18 + .25 }rem`
		}

		map_or_editor(): readonly ( any )[] {
			return (this.editor_mode_enabled())
				? [this.Editor()] : [this.Map_page(), ... this.drawing_tools_visible() ? [this.Floating_tools()] : []]
		}

		rights_team( next?: $shm_hitalama_team | null ) {
			return this.Head().team( next )
		}

		@ $mol_action
		rights_close() {
			this.rights_visible( false )
			return null
		}
		
		id( id: any ): string {
			return id
		}

		@ $mol_action
		map_cut() {
			$shm_hitalama_profile.current()?.cut_map( this.map().link() )
		}
		
		widget_for_editor() {
			const ref = this.$.$mol_state_arg.value( 'edit_widget' )! 
				?? this.Map_page().selected_links().at(0)?.toString() 
			
			if( !ref ) return null

			this.$.$mol_state_arg.value( 'edit_widget', ref )!

			return this.map().widget( ref )
		}

		@ $mol_mem
		widget_for_settings() {//overlay map pull it to, so it can be broken
			const sel_link = this.selected_links().at(0)?.toString()
			const requested = this.$.$mol_state_arg.value( 'widget_props' )

			const ref = this.Head().widget_props_visible()
				? sel_link
				: sel_link == requested
					? requested
					: null

			if( !ref ) {
				// Clearing an already absent parameter schedules replaceState with an
				// old URL and can undo a native link click before its hashchange.
				if( requested && this.$.$mol_state_arg.value( 'map' ) == this.map().link().str ) {
					this.$.$mol_state_arg.value( 'widget_props', null )
				}

				return null
			}

			if( !ref ) return null
			return this.map().widget( ref )
		}

	}
}
